module.exports = __webpack_public_path__ + "static/img/logo73.d6a6021.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo73.png
// module id = SxTF
// module chunks = 1